import { PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { green, grey, white } from './colors';
import { buildPaletteFromMetadata, PaletteTokenMetadata, Token } from './panw-palette/token-metadata';

/** For use strictly within @chronosphereio/chrono-ui */
const switchTokens = [
  { propertyPath: 'thumbCheckedColor', tokenName: '--bg-interactive-control-handle' },
  { propertyPath: 'thumbDisabledColor', tokenName: '--bg-interactive-control-handle-disabled' },
  { propertyPath: 'thumbUncheckedColor', tokenName: '--bg-interactive-control-handle' },
  { propertyPath: 'trackDisabledColor', tokenName: '--bg-interactive-control-disabled' },
  { propertyPath: 'trackCheckedColor', tokenName: '--bg-interactive-control-selected' },
  { propertyPath: 'trackCheckedHoverColor', tokenName: '--bg-interactive-control-selected-hover' },
  { propertyPath: 'trackHoverColor', tokenName: '--bg-interactive-control-default-hover' },
  { propertyPath: 'trackUncheckedColor', tokenName: '--bg-interactive-control-default' },
] satisfies Token[];

export const switchTokenMetadata: PaletteTokenMetadata = {
  componentName: 'switch',
  tokens: switchTokens,
};

export const switchPalette = (mode: PaletteMode, opts: GetThemeOptions): NonNullable<PaletteOptions['switch']> => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    return buildPaletteFromMetadata(switchTokenMetadata.tokens, semanticTokens, xcorTokens);
  }

  return mode === 'light'
    ? {
        trackCheckedColor: green[600],
        trackUncheckedColor: grey[400],
        thumbColor: white,
        thumbDisabledColor: grey[100],
        thumbUncheckedColor: white,
        // we don't actually use these in the legacy world
        thumbCheckedColor: white,
        trackCheckedHoverColor: white,
        trackDisabledColor: grey[100],
      }
    : {
        trackCheckedColor: green[600],
        trackUncheckedColor: grey[600],
        thumbColor: white,
        thumbDisabledColor: grey[700],
        thumbUncheckedColor: white,
        // we don't actually use these in the legacy world
        thumbCheckedColor: white,
        trackCheckedHoverColor: white,
        trackDisabledColor: grey[700],
      };
};
